module.exports = __webpack_public_path__ + "static/media/menu-hats.fd0f5c7d.png";